import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  listItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    "& div": {
      fontSize: "90%",
    },
    "& span": {
      fontSize: "85%",
    },
  },
  listContainer: {
    width: theme.spacing(142),
    minHeight: theme.spacing(60),
    maxHeight: theme.spacing(110),
    "& :hover": {
      color: theme.palette.primary.main,
    },
  },
  icon: {
    fontSize: theme.fontSize["16"],
    opacity: 0.5,
    marginRight: theme.spacing(2),
  },
  iconContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    color: theme.palette.secondary.main,
  },
  image: {
    width: theme.spacing(52),
    height: theme.spacing(42),
  },
  EmptyContainer: {
    height: theme.spacing(60),
    width: theme.spacing(142),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  EmptyText: {
    opacity: 0.5,
    color: theme.palette.secondary.tint60,
  },
  loaderContainer: {
    width: theme.spacing(142),
    height: theme.spacing(60),
  },
}));
